require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-hackerberg.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-hackerberg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-hackerberg!./.cache/json/betreuungseinrichtungen-guessing-hackerberg.json
// module id = 889
// module chunks = 231608221292675